import { Api } from '../../common/api/const';
import TrainingCenterDTO from '../model/dto-get/trainingCenterDTO';

export class TrainingCentersApiService {
    static fetchTrainingCenters = () => Api().get(`/trainingCenter`);
    static postTrainingCenter = (trainingCenterDTO: TrainingCenterDTO) => Api().post(`/trainingCenter`, trainingCenterDTO);
    static putTrainingCenter = (trainingCenterDTO: TrainingCenterDTO) => Api().put(`/trainingCenter/${trainingCenterDTO?.id}`, trainingCenterDTO);
    static replace = (o: string, n: string) => Api().post(`/trainingCenter/${o}/to/${n}`);
}
